<template>
  <div class="check-wrap">
    <label @click="clickOnDisabled(disabled)">
      <input
        type="checkbox"
        :value="isChecked ? 1 : 0"
        :name="checkboxName"
        :disabled="disabled"
        :checked="isChecked ? 1 : 0"
        :class="[{'checked': isChecked }]"
        @click="changeValue()"
      >
      <span class="checkbox-label">{{ checkboxLabel }}</span>
      <slot />
    </label>
  </div>
</template>

<script>
  export default {
    props: {
      isChecked: {
        type: Boolean,
        default: false
      },
      checkboxLabel: {
        type: String,
        required: true
      },
      checkboxName: {
        type: String,
        default: '',
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      changeValue () {
        this.$emit('updated', !this.isChecked)
      },

      clickOnDisabled (isDisabled) {
        if (isDisabled) {
          this.$emit('clickDisabled')
        }
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .check-wrap {

    label {
      cursor: pointer;
    }
  }

  input[type="checkbox"] {
    display: none;

    &.checked + span:before {
      content: $icon-checkmark-medium;
      @include icon-font();
      font-size: em(10);
      text-align: center;
    }
  }

  .checkbox-label:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
  }
</style>
